import { scrollToTop } from '@anm/helpers/scrolling';
import { useEffect, useRef } from 'react';

const useScrollToUploadingVideo = (isUploadInProgress: boolean) => {
  const TOP_OFFSET = 100;
  const containerRef = useRef<HTMLDivElement>(null);
  const elementRect = containerRef.current?.getBoundingClientRect();

  useEffect(() => {
    if (!isUploadInProgress || !elementRect) return;

    const isInView = window.innerHeight > elementRect.top;

    !isInView && scrollToTop(elementRect.top - TOP_OFFSET);
  }, [isUploadInProgress, elementRect]);

  return [containerRef] as const;
};

export default useScrollToUploadingVideo;
